import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    List,
    ListItem,
    Typography,
    Grid
} from '@mui/material'
import {observer} from 'mobx-react-lite'
import {useToLocaleDateStringFromRoute} from '@oc/shell-core'
import {keyBoardPressActions} from '@oc/utils'
import {makeStyles} from '@oc/styles'
import {messages} from '../../translations'
import {RkLastDataChangeState} from './RkLastDataChangeState'

const useStyles = makeStyles(theme => ({
    paper: {
        minWidth: '50%',
        maxWidth: '70%',
        minHeight: '40vh',
        maxHeight: '60vh'
    },
    list: {
        alignItems: 'center',
        justifyContent: 'center'
    },
    listItemsHeader: {
        marginLeft: theme.spacing(2)
    }
}))

interface RKChangesAfterLastDeployDialogProps {
    state: RkLastDataChangeState
}

function _RKChangesAfterLastDeployDialog({state}: RKChangesAfterLastDeployDialogProps) {
    const {classes} = useStyles()
    const toLocaleDateString = useToLocaleDateStringFromRoute()

    return (
        <Dialog
            onKeyDown={event => {
                keyBoardPressActions(
                    event,
                    state.closeDialog,
                    state.closeDialog,
                    undefined,
                    undefined,
                    state.dialogOpen
                )
            }}
            open={state.dialogOpen}
            keepMounted={false}
            fullScreen
            classes={{paper: classes.paper}}
            data-cy="rk-changes-dialog"
        >
            <DialogTitle>
                {messages.getText(
                    'headers',
                    'rkChangesAfterLastDeploy',
                    state.lastDeploymentTimestamp
                        ? toLocaleDateString(state.lastDeploymentTimestamp)
                        : messages.getText('misc', 'never')
                )}
            </DialogTitle>
            <DialogContent>
                <Grid container className={classes.list}>
                    <Grid item xs={6}>
                        <Typography className={classes.listItemsHeader} variant="h6">
                            {messages.getText('names', 'resource')}
                        </Typography>
                        <List component="nav" className={classes.list}>
                            {state.changedResources.map(([resource]) => (
                                <ListItem key={`list-item-resource-${resource}`}>
                                    {messages.getText('resources', resource as any) || resource}
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography className={classes.listItemsHeader} variant="h6">
                            {messages.getText('names', 'lastChange')}
                        </Typography>
                        <List component="nav" className={classes.list}>
                            {state.changedResources.map(([resource, timestamp]) => (
                                <ListItem key={`list-item-timestamp-${resource}`}>
                                    {toLocaleDateString(timestamp)}
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button data-cy="rk-changes-dialog-confirm-button" onClick={state.closeDialog} color="primary">
                    {messages.getText('buttons', 'confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export const RKChangesAfterLastDeployDialog = observer(_RKChangesAfterLastDeployDialog)
